module.exports = __webpack_public_path__ + "media/images/views/lp/client/choose-sourcedout/client-benefit-02-a8c96394986631e83302ea3f1830f4c6.png";